/**
 * constant to track the corresponding filed level error message for page level error
 */

const INLINE_ACCOUNT_NUMBER_ERROR = {
  messageKey: 'INLINE_ACCOUNT_NUMBER_ERROR',
  filedName: 'accountnumber'
}

const INLINE_INCORRECT_CITY = {
  messageKey: 'INLINE_INCORRECT_CITY',
  filedName: 'city'
}

const INLINE_INCORRECT_STATE = {
  messageKey: 'INLINE_INCORRECT_STATE',
  filedName: 'state'
}

const INLINE_INCORRECT_ZIP_CODE = {
  messageKey: 'INLINE_INCORRECT_ZIP_CODE',
  filedName: 'zipcode'
}

const INLINE_INVALID_ADDRESS = {
  messageKey: 'INLINE_INVALID_ADDRESS',
  filedName: 'addressLine1'
}
const fieldLevelErrorMapping = {
  '409.1100.2109': { ...INLINE_ACCOUNT_NUMBER_ERROR },
  '409.1100.2255': { ...INLINE_ACCOUNT_NUMBER_ERROR },
  '400.2222.4063': {
    ...INLINE_ACCOUNT_NUMBER_ERROR
  },
  '400.2222.4059': {
    ...INLINE_ACCOUNT_NUMBER_ERROR
  },
  '409.2222.4233': {
    messageKey: 'INLINE_SEARCH_ACCOUNT_NUMBER',
    filedName: 'accountnumber'
  },
  '409.2222.4004': {
    messageKey: 'INLINE_ACCOUNT_NUMBER_REQUIRED',
    filedName: 'accountnumber'
  },
  '409.1600.2211': { ...INLINE_INCORRECT_CITY },
  '409.1600.2212': { ...INLINE_INCORRECT_CITY },
  '409.1600.2225': { ...INLINE_INCORRECT_CITY },
  '409.1600.2226': { ...INLINE_INCORRECT_CITY },
  '409.1100.2262': { ...INLINE_INCORRECT_CITY },
  '409.1100.2263': { ...INLINE_INCORRECT_CITY },
  '409.1100.2276': { ...INLINE_INCORRECT_CITY },
  '409.1100.2274': { ...INLINE_INCORRECT_CITY },
  '409.1100.2275': { ...INLINE_INCORRECT_CITY },
  '409.1100.2277': { ...INLINE_INCORRECT_CITY },
  '409.2222.4010': { ...INLINE_INCORRECT_CITY },
  '409.1600.2213': { ...INLINE_INCORRECT_STATE },
  '409.1600.2214': { ...INLINE_INCORRECT_STATE },
  '409.1600.2227': { ...INLINE_INCORRECT_STATE },
  '409.1600.2228': { ...INLINE_INCORRECT_STATE },
  '409.1100.2264': { ...INLINE_INCORRECT_STATE },
  '409.1100.2265': { ...INLINE_INCORRECT_STATE },
  '409.1100.2278': { ...INLINE_INCORRECT_STATE },
  '409.2222.4011': { ...INLINE_INCORRECT_STATE },
  '409.2222.4015': { ...INLINE_INCORRECT_STATE },
  '409.1100.2279': { ...INLINE_INCORRECT_STATE },
  '409.2222.4053': { ...INLINE_INCORRECT_STATE },
  '409.1600.2215': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.1600.2216': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.1600.2229': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.1600.2230': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.1100.2268': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.1100.2266': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.1100.2267': { ...INLINE_INCORRECT_ZIP_CODE },
  '400.1100.2290': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.2222.4006': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.2222.4007': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.2222.4008': { ...INLINE_INCORRECT_ZIP_CODE },
  '400.2222.4062': { ...INLINE_INCORRECT_ZIP_CODE },
  '409.2222.4009': { ...INLINE_INVALID_ADDRESS },
  '400.2222.4064': { ...INLINE_INVALID_ADDRESS },
  '409.1600.2205': { ...INLINE_INVALID_ADDRESS },
  '409.2222.4017': { ...INLINE_INVALID_ADDRESS },
  '409.2222.4005': { ...INLINE_INVALID_ADDRESS },
  '409.1600.2206': { ...INLINE_INVALID_ADDRESS },
  '409.1600.2207': { ...INLINE_INVALID_ADDRESS },
  '409.1600.2208': { ...INLINE_INVALID_ADDRESS },
  '409.1600.2209': { ...INLINE_INVALID_ADDRESS },
  '409.1600.2210': { ...INLINE_INVALID_ADDRESS },
  '409.1100.2256': { ...INLINE_INVALID_ADDRESS },
  '409.1100.2257': { ...INLINE_INVALID_ADDRESS },
  '409.1100.2258': { ...INLINE_INVALID_ADDRESS },
  '409.1100.2259': { ...INLINE_INVALID_ADDRESS },
  '409.1100.2260': { ...INLINE_INVALID_ADDRESS },
  '409.1100.2261': { ...INLINE_INVALID_ADDRESS },
  '409.1100.4080': {
    hasSystemError: false,
    isReplaceContent: true,
    pattern: '<Merchant>'
  },
  '409.1100.4070': {
    hasSystemError: false,
    isReplaceContent: true,
    pattern: '<Merchant>'
  },
  '500.1100.4000': {
    hasSystemError: false,
    isReplaceContent: true,
    pattern: '<Merchant>'
  },
  '409.1100.4071': {
    hasSystemError: false,
    hasInlineMessage: true,
    inlineMessage:
      'This account number already exists in your list of bills. Please enter a different number.'
  },
  '500.1100.4003': {
    isRecoverable: false,
    hasSystemError: true,
    pattern: '<#>',
    isReplaceContent: true,
    showCount: true,
    displayMessage:
      '<#> bills were not added. Add them manually or try again later.'
  },
  '500.1100.4004': {
    isRecoverable: false,
    hasSystemError: true,
    pattern: '<#>',
    isReplaceContent: true,
    showCount: true,
    displayMessage:
      '<#> bills were not added. Add them manually or try again later.'
  },
  '500.2222.4089': {
    isRecoverable: false,
    hasSystemError: true,
    pattern: '<#>',
    isReplaceContent: true,
    showCount: true,
    displayMessage:
      '<#> bills were not added. Add them manually or try again later.'
  },
  '500.1100.4006': {
    isRecoverable: false,
    hasSystemError: true,
    CTA: 'Call 800-872-2657',
    isReplaceContent: false
  },
  '409.1100.4050': {
    isRecoverable: false,
    title: "Our system isn't cooperating",
    hasSystemError: true,
    CTA: '',
    isReplaceContent: true,
    pattern: '<Merchant>'
  },
  '500.1100.4001': {
    isRecoverable: false,
    hasSystemError: true,
    pattern: '<#>',
    isReplaceContent: true,
    showCount: true,
    displayMessage:
      '<#> bills were not added. Add them manually or try again later.'
  },
  '500.1100.4002': {
    isRecoverable: false,
    hasSystemError: true,
    CTA: 'Call 800-872-2657',
    isReplaceContent: false
  },
  '409.2222.4090': {
    isReplaceContent: true,
    hasSystemError: false,
    pattern: '<Merchant>'
  },
  '500.1100.4005': {
    isRecoverable: false,
    hasSystemError: true
  },
  '400.1100.4051': {
    hasSystemError: false
  },
  '400.1100.4052': {
    isRecoverable: false,
    hasSystemError: true
  },
  '500.6666.4000': {
    isRecoverable: false,
    hasSystemError: true,
    CTA: 'Call 800-872-2657'
  },
  '400.6666.4050': {
    isRecoverable: false,
    hasSystemError: true,
    CTA: 'Call 800-872-2657'
  },
  '409.6666.4070': {
    hasSystemError: false
  }
}

export default fieldLevelErrorMapping
